<template>
  <v-row>
    <v-col sm="6" cols="12">
      <v-select
        :disabled="!canEdit"
        :items="timeRangeItems"
        item-value="value"
        item-title="title"
        v-model="selectedTimeRange"
        :label="$t('common.filters.timeRange')"
        :menu-props="{ scrollStrategy: 'none' }"
      ></v-select>
    </v-col>
    <v-col sm="6" cols="12">
      <v-menu
        ref="datePickerMenu"
        v-model="datePickerMenu"
        :close-on-content-click="false"
        transition="scale-transition"
        scroll-strategy="none"
        max-width="290px"
        min-width="290px"
      >
        <template v-slot:activator="{ props }">
          <v-text-field
            v-model="dateRangeText"
            readonly
            :placeholder="$t('common.placeholders.selectDates')"
            :disabled="selectedTimeRange !== 'custom' || !canEdit"
            v-bind="props"
          ></v-text-field>
        </template>
        <v-date-picker v-model="dates" range>
          <v-spacer></v-spacer>
          <v-btn variant="text" color="primary" @click="datePickerMenu = false">{{
            $t("common.actions.cancel")
          }}</v-btn>
          <v-btn
            variant="text"
            color="primary"
            :disabled="dates[0] === undefined || dates[1] === undefined"
            @click="onSavePickedDate()"
            >{{ $t("common.actions.ok") }}</v-btn
          >
        </v-date-picker>
      </v-menu>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: ["canEdit", "return-value"],
  emits: ["update:return-value"],
  data() {
    return {
      dates: [],
      datePickerMenu: false,
      selectedTimeRange: "today",
      dateRangeText: ""
    }
  },
  created() {
    this.setDateRange()
  },
  computed: {
    timeRangeItems() {
      return [
        { title: this.$t("common.enums.day.today"), value: "today" },
        {
          title: `${this.$t("common.filters.last")} ${this.$t(
            "common.units.day",
            7
          )}`,
          value: "7 days"
        },
        {
          title: `${this.$t("common.filters.last")} ${this.$t(
            "common.units.day",
            30
          )}`,
          value: "30 days"
        },
        { title: this.$t("common.filters.customRange"), value: "custom" }
      ]
    }
  },
  watch: {
    selectedTimeRange(newRange) {
      if (newRange !== "custom") {
        this.setDateRange()
      } else {
        // Display date picker. OK callback will trigger fetch
        this.datePickerMenu = true
      }
    },
    dates(newDates) {
      // Always set earliest date as start date
      if (newDates[0] > newDates[1]) {
        newDates.reverse()
      }
      this.dateRangeText = newDates.join(" ~ ")
      this.$emit("update:return-value", this.dates)
    }
  },
  methods: {
    setDateRange() {
      let startDate = new Date()
      let offset = 0

      if (this.selectedTimeRange === "today") {
        offset = 0
      } else if (this.selectedTimeRange === "7 days") {
        offset = 6 // Becomes 7 since today will be included
      } else if (this.selectedTimeRange === "30 days") {
        offset = 29 // Becomes 30 since today will be included
      }

      startDate.setDate(startDate.getDate() - offset)
      this.dates = [
        startDate.toISOString().substring(0, 10),
        new Date().toISOString().substring(0, 10)
      ]
    },
    onSavePickedDate() {
      this.datePickerMenu = false
      this.dateRangeText = this.dates.join(" ~ ")
    }
  }
}
</script>
<style></style>
